import { Component, OnInit ,ViewChild} from '@angular/core';
import { NavController, IonSlides, Platform, IonRouterOutlet } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';

@Component({
  selector: 'app-guided-tour',
  templateUrl: './guided-tour.component.html',
  styleUrls: ['./guided-tour.component.scss'],
})
export class GuidedTourComponent implements OnInit {

  @ViewChild(IonRouterOutlet,{static: true}) routerOutlet: IonRouterOutlet;

  context: any;
  langcontext: any;
  slidelast: any;

  constructor(public navCtrl: NavController,public platform: Platform,public cmndeclaration: CommonDeclarationService, public cmndef: CommonDefinitionService) { 
    this.slidelast = 0;
    if(this.cmndeclaration.LanguageJson){
      this.langcontext = this.cmndeclaration.LanguageJson.pages[0]['Guidertour'];
      this.context = this.langcontext.tourInformation;
    }
    else{
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndeclaration.LanguageJson['pages'][0].Guidertour;
      this.context = this.langcontext.tourInformation;
    }
    console.log(this.context)
    this.platform.ready().then(data=>{
      this.platform.backButton.subscribe(() => {
       console.log("Its working");
       console.log("Hello Its working");
      });
    });
  }

  ngOnInit() {

  }
  
  slideChanged(testSlider: any){
   testSlider.getActiveIndex().then(data=>{
     this.slidelast = data;
   })
  }

  tourcomplete(){
    console.log("finished");
    localStorage.tourstatus='Visited';
    sessionStorage.CurrentPage="/preRegister";
    this.navCtrl.navigateForward("/preRegister");
  }
}
